idsToRemove